module.exports = __webpack_public_path__ + "static/media/emergencia.68972675.png";